// removed by extract-text-webpack-plugin
module.exports = {"mediaContainer":"u6QPN","inTeaser":"_2kMEM","imageContainer":"_1RZas","mcTitle":"_3JZ24","mediaContainerMobile":"_1JkXF u6QPN","mcInfo":"_1bQaE","infoContainer":"_1_seQ","mcLink":"iPKdf","mcLinkInner":"_29nTd","bi-arrow-right":"ZyHR2","imageLoaded":"vKS1L _3_A3j","playIconWrap":"LySHF","image":"_3_A3j"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MediaContainer/style.scss
// module id = ECpV
// module chunks = 0